import clsx from 'clsx'

import { GameIcon } from '@/shared/ui/GameIcon'

import { useResourceContext } from './context'

export const Rewards = ({
  className = '',
  orientation = 'horizontal',
  textColor = 'text-gray-700'
}) => {
  const {
    pointsReward,
    coinsReward,
    pointsAcquired,
    coinsAcquired,
    hasRewards
  } = useResourceContext()
  const horizontal = orientation === 'horizontal'

  if (!hasRewards) return null

  return (
    <div
      className={clsx(
        'reward-badge-group',
        !horizontal && 'flex-col gap-2',
        className
      )}
    >
      {!!pointsReward && (
        <span
          className={clsx(
            'reward-badge reward-badge--inline reward-badge--xp',
            textColor
          )}
        >
          <span className="reward-badge__icon">
            <GameIcon name="star" size={12} alt="" />
          </span>
          <span className="reward-badge__value">
            {pointsAcquired}/{pointsReward}
          </span>
          <span className="reward-badge__label">XP</span>
        </span>
      )}
      {!!coinsReward && (
        <span
          className={clsx(
            'reward-badge reward-badge--inline reward-badge--coins',
            textColor
          )}
        >
          <span className="reward-badge__icon">
            <GameIcon name="coins" size={12} alt="" />
          </span>
          <span className="reward-badge__value">
            {coinsAcquired}/{coinsReward}
          </span>
          <span className="reward-badge__label">moedas</span>
        </span>
      )}
    </div>
  )
}
